import { Fragment, useContext } from "react";
import { dataAccountLinkInventory } from "../utils";
import { BaseTable, Loading } from "components";
import { Create } from "./Create";
import { LinkAccountContext } from "pages/Setup/contexts";


export function TableContent() {
  // Hooks
  
 const { data, refetch, isLoading } = useContext(LinkAccountContext)

  return (
    <Fragment>
      {isLoading ? (
        <Loading loading={isLoading} />
      ) : (
        <div className="border">
          {dataAccountLinkInventory.map((i, key) => (
            <div key={key}>
              <div className="border p-4">
                <span className="font-bold">{i.Header}</span>
              </div>
              <div>
                <div className="p-4">
                  <BaseTable className="table">
                    <thead>
                      <tr>
                        <th className="border">CODE</th>
                        <th className="border" colSpan={2}>DESCRIPTION</th>
                        <th className="border">NUMBER</th>
                        <th className="border">COA NAME</th>
                      </tr>
                    </thead>
                    <tbody>
                      {i.LinkAccount.map((item, index) => {
                        // Vars
                        const coa = data.find(list => list.linked_account_code === item.linked_account_code)

                        return (
                          <tr key={index}>
                            <td className="border w-[100px]">{item?.linked_account_code}</td>
                            <td className="border w-[300px]">{item?.description}</td>
                            <td className="border text-center w-[100px]">
                              <Create
                                dataItem={item}
                                refetch={refetch}
                              />
                            </td>
                            <td className="border w-[200px]">{coa ? `${coa.coa_code}` : ''}</td>
                            <td className="border w-[200px]">{coa?.coa_name}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </BaseTable>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Fragment>
  )
}